<template lang="html">
  <div class="input-query" id="to-here">
    <div class="columns">
      <div class="column">
        <div class="input-container">
          <div class="field">
            <label class="label" v-html="label"></label>
            <div class="select" v-if="showSelect">
              <select v-model="cod_camara">
                <option selected disabled value="">Seleccione una cámara</option>
                <option v-for="(camera, index) in cameras" :value="camera.id">{{ camera.name }}</option>
              </select>
            </div>
            <p class="control">
              <input class="input" :type="type" @keyup.enter="send" :placeholder="placeholder" v-model="value" :disabled="$root.sending" id="focus-here">
            </p>
            <p class="help is-danger" v-if="$root.has_error && !$root.show_details">{{ $root.message }}</p>
          </div>
          <div class="field">
            <p class="control">
              <button class="button is-info" :disabled="$root.sending" :class="{ 'is-loading' : $root.sending }" @click="send">
                Consultar
              </button>
            </p>
          </div>
        </div>
      </div>
      <div class="column" id="results-query">
        <span class="content-powered">
          <span class="text-data">Datos de </span>
          <a :href="providedImage.href" :target="providedImage.new_tab ? '_blank' : false">
            <img :src="providedImage.src" alt="Sponsor"  class="image-sponsor">
          </a>
        </span>
      </div>
    </div>
    <div class="columns" v-if="!isEmpty">
      <div class="column">
        <base-list-items :enterprises-data="enterprises" :is-rnt="isRnt" :is-rup="isRup" :is-esal="isEsal" :is-rem="isRem" :is-runeol="isRuneol" :is-query="queryToSii"></base-list-items>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: String,
    label: String,
    api: String,
    nameInput: String,
    showSelect: Boolean,
    isRem: Boolean,
    isRup: Boolean,
    isEsal: Boolean,
    isRnt: Boolean,
    isRuneol: Boolean,
    type: String,
    attributes: Object,
    queryToSii: Boolean,
    providedImage: Object
  },
  methods: {
    send() {
      let vm = this
      vm.enterprises = []
      vm.$root.has_error = false
      vm.$root.sending = !vm.$root.sending
      vm.object_data[vm.nameInput] = vm.value
      if (!vm.queryToSii)
       vm.object_data.codCamara = vm.cod_camara
      else
       vm.object_data.codigoempresa = vm.cod_camara

      if (vm.object_data[vm.nameInput] != '') {
        axios.post(vm.api, vm.object_data)
        .then(function (response) {
          const r = response.data
          if (r.codigo_error == '0000' || r.codigoerror == '0000') {
            if (!vm.queryToSii)
              vm.enterprises = r.rows
            else
              vm.enterprises.push(r)
          } else if (r.codigo_error == '0001' || r.codigoerror == '0001') {
            if (!vm.queryToSii)
              vm.$root.message = r.mensaje_error
            else
              vm.$root.message = r.mensajeerror
            vm.$root.has_error = true
          } else {
            if (!vm.queryToSii)
              vm.$root.message = r.mensaje_error
            else
              vm.$root.message = r.mensajeerror
            vm.$root.has_error = true
          }
          vm.$root.sending = !vm.$root.sending
        })
        .catch(function (error) {
          console.log(error)
          vm.$root.message = 'Ha ocurrido un error en el servidor, vuelva a consultar por favor.'
          vm.$root.has_error = true
          vm.$root.sending = !vm.$root.sending
        })
      } else {
        vm.$root.message = 'El campo no puede estar vacio'
        vm.$root.has_error = true
        vm.$root.sending = !vm.$root.sending
      }
    }
  },
  computed: {
    isEmpty() {
      let vm = this
      return _.isEmpty(vm.enterprises)
    }
  },
  data() {
    return {
      value: '',
      cod_camara: '',
      object_data: {
        codCamara: '',
        codigoempresa: '',
        txtNombre: '',
        txtNIT: '',
        txtNumReconocimiento: '',
        method: this.attributes ? this.attributes.method : '',
        semilla: this.attributes ? this.attributes.semilla : '',
        matriculainicial: this.attributes ? this.attributes.matriculainicial : '',
        identificacion: this.attributes ? this.attributes.identificacion : '',
        matricula: this.attributes ? this.attributes.matricula : '',
        proponente: this.attributes ? this.attributes.proponente : '',
        tipo: this.attributes ? this.attributes.tipo : ''
      },
      enterprises: [],
      cameras: [
        {
          id: '55',
          name: 'ABURRA SUR'
        },
        {
          id: '53',
          name: 'AGUACHICA'
        },
        {
          id: '42',
          name: 'AMAZONAS'
        },
        {
          id: '48',
          name: 'ARAUCA'
        },
        {
          id: '01',
          name: 'ARMENIA'
        },
        {
          id: '02',
          name: 'BARRANCABERMEJA'
        },
        {
          id: '03',
          name: 'BARRANQUILLA'
        },
        {
          id: '04',
          name: 'BOGOTA'
        },
        {
          id: '05',
          name: 'BUCARAMANGA'
        },
        {
          id: '06',
          name: 'BUENAVENTURA'
        },
        {
          id: '07',
          name: 'BUGA'
        },
        {
          id: '08',
          name: 'CALI'
        },
        {
          id: '09',
          name: 'CARTAGENA'
        },
        {
          id: '10',
          name: 'CARTAGO'
        },
        {
          id: '50',
          name: 'CASANARE'
        },
        {
          id: '28',
          name: 'CAUCA'
        },
        {
          id: '12',
          name: 'CHINCHINA'
        },
        {
          id: '29',
          name: 'CHOCÓ'
        },
        {
          id: '98',
          name: 'CONFECAMARAS'
        },
        {
          id: '11',
          name: 'CUCUTA'
        },
        {
          id: '54',
          name: 'DOSQUEBRADAS'
        },
        {
          id: '13',
          name: 'DUITAMA'
        },
        {
          id: '47',
          name: 'FACATATIVA'
        },
        {
          id: '41',
          name: 'FLORENCIA PARA EL CAQUETA'
        },
        {
          id: '14',
          name: 'GIRARDOT'
        },
        {
          id: '15',
          name: 'HONDA'
        },
        {
          id: '16',
          name: 'IBAGUE'
        },
        {
          id: '17',
          name: 'IPIALES'
        },
        {
          id: '18',
          name: 'LA DORADA'
        },
        {
          id: '30',
          name: 'LA GUAJIRA'
        },
        {
          id: '19',
          name: 'MAGANGUE'
        },
        {
          id: '52',
          name: 'MAGDALENA MEDIO'
        },
        {
          id: '20',
          name: 'MANIZALES'
        },
        {
          id: '21',
          name: 'MEDELLIN PARA ANTIOQUIA'
        },
        {
          id: '22',
          name: 'MONTERIA'
        },
        {
          id: '23',
          name: 'NEIVA'
        },
        {
          id: '49',
          name: 'OCANA'
        },
        {
          id: '51',
          name: 'ORIENTE ANTIOQUENO'
        },
        {
          id: '24',
          name: 'PALMIRA'
        },
        {
          id: '25',
          name: 'PAMPLONA'
        },
        {
          id: '26',
          name: 'PASTO'
        },
        {
          id: '27',
          name: 'PEREIRA '
        },
        {
          id: '56',
          name: 'PIEDEMONTE ARAUCANO'
        },
        {
          id: '46',
          name: 'PUTUMAYO'
        },
        {
          id: '31',
          name: 'SAN ANDRES'
        },
        {
          id: '57',
          name: 'SAN JOSE'
        },
        {
          id: '32',
          name: 'SANTA MARTA'
        },
        {
          id: '33',
          name: 'SANTA ROSA DE CABAL'
        },
        {
          id: '43',
          name: 'SEVILLA'
        },
        {
          id: '34',
          name: 'SINCELEJO'
        },
        {
          id: '35',
          name: 'SOGAMOSO'
        },
        {
          id: '45',
          name: 'SUR Y ORIENTE DEL TOLIMA'
        },
        {
          id: '36',
          name: 'TULUA'
        },
        {
          id: '37',
          name: 'TUMACO'
        },
        {
          id: '38',
          name: 'TUNJA'
        },
        {
          id: '44',
          name: 'URABA'
        },
        {
          id: '39',
          name: 'VALLEDUPAR'
        },
        {
          id: '40',
          name: 'VILLAVICENCIO'
        }
      ]
    }
  },
  mounted() {
    let vm = this
    vm.$root.has_error = false
    vm.object_data[vm.nameInput] = ''
    document.getElementById('focus-here').focus()
  }
}
</script>

<style lang="sass" scoped>
  @import "~@"

  select, input
    &:focus, &:active, &.is-focused, &.is-active
      border-color: $color-title
      box-shadow: 0 0 0 0.125em rgba($color-title, 0.52)
  .select
    margin-bottom: 10px
    & select
      width: 100%
    &:not(.is-multiple)
      &:not(.is-loading)
        &:after
          border-color: $color-title

  .select, .control
    width: 100%

  .image-sponsor
    width: 80px
    margin-left: 10px

  .content-powered
    color: #4f4f4f
    display: flex
    align-items: center
    & .text-data
      font-size: .6em
    & a
      display: flex
      align-items: center
</style>



// WEBPACK FOOTER //
// resources/js/components/BaseInputQuery.vue